/* External */
import { Children, memo, useMemo } from 'react';
import PropTypes from 'prop-types';

/* Styles */
import './OrderedList.scss';

function OrderedList({
  centered,
  className,
  horizontal,
  children,
}) {
  const classesNames = [
    className,
    centered ? 'dtv-html5-c-ordered-list--centered' : '',
    horizontal ? 'dtv-html5-c-ordered-list--horizontal-aligned' : '',
  ];
  const listItems = useMemo(
    () => Children.map(children, (child) => (
      <li className="dtv-html5-c-ordered-list__item">{child}</li>
    )),
    [children],
  );

  return (
    <ol className={`dtv-html5-c-ordered-list ${classesNames.join(' ')}`}>
      {listItems}
    </ol>
  );
}

OrderedList.defaultProps = {
  centered: false,
  className: '',
  horizontal: false,
  children: [],
};

OrderedList.propTypes = {
  centered: PropTypes.bool,
  className: PropTypes.string,
  horizontal: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node),
};

export default memo(OrderedList);
